import React from 'react';
import { Users } from 'lucide-react';
import { Button } from '../../ui/Button';

/**
 * Convert plain text containing URLs into JSX, turning URLs into anchors.
 * Exported so other zone sections can reuse the same linkification.
 */
export function renderTextWithLinks(text) {
    if (!text) return null;
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const parts = text.split(urlRegex);
    return parts.map((part, index) => {
        if (part.match(urlRegex)) {
            return (
                <a
                    key={index}
                    href={part}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-brand-700 hover:text-brand-800 hover:underline"
                >
                    {part}
                </a>
            );
        }
        return <React.Fragment key={index}>{part}</React.Fragment>;
    });
}

/**
 * About tab — shows the zone's free-text description plus an entry-point
 * button to the community-members modal.
 */
export function AboutTab({ zoneDescription, onOpenMembers }) {
    return (
        <div className="py-2 max-w-4xl mx-auto">
            <div className="mb-6">
                <p className="eyebrow text-brand-700 mb-1">על הקהילה</p>
                <h2 className="heading-lg text-ink">סיפור המקום</h2>
            </div>

            <article
                className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-brand-50/60 via-surface to-secondary-50/40 ring-1 ring-brand-100/70 shadow-soft p-6 sm:p-8"
            >
                <span aria-hidden="true" className="absolute -top-16 -end-10 w-60 h-60 rounded-pill blur-3xl bg-brand-200/40 pointer-events-none" />
                <div
                    className="relative text-ink leading-relaxed break-words text-base sm:text-lg"
                    style={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}
                >
                    {renderTextWithLinks(zoneDescription)}
                </div>
            </article>

            <div className="flex justify-center mt-6">
                <Button
                    variant="outline"
                    size="md"
                    icon={<Users />}
                    onClick={onOpenMembers}
                >
                    הכירו את חברי הקהילה
                </Button>
            </div>
        </div>
    );
}

export default AboutTab;
